"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
function NewsGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(3)].map((_, i) => <Card key={i} data-index={i} className="rounded-lg border-none shadow-md h-[400px] animate-pulse bg-muted/50" />)}
      </div>;
  }
  if (error) {
    return <div className="p-8 text-center text-muted-foreground border border-border rounded-lg">
        <p>Neuigkeiten konnten nicht geladen werden. | Updates currently unavailable.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="p-8 text-center text-muted-foreground border border-border rounded-lg">
        <p>Momentan gibt es keine neuen Beiträge. | No news at the moment.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="rounded-lg border border-border/50 shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group bg-card/80 backdrop-blur-sm flex flex-col">
          <div className="relative">
            <AspectRatio ratio={4 / 5}>
              <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638561/img/landkinder_news_preview.png"} alt={post.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110" />
            </AspectRatio>
            {post.date && <Badge variant="secondary" className="absolute top-4 right-4 rounded-lg bg-secondary/90 text-secondary-foreground px-3 py-1 text-xs font-default shadow-sm backdrop-blur-md">
                {new Date(post.date).toLocaleDateString('de-DE', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
          })}
              </Badge>}
          </div>
          <CardContent className="p-6 flex flex-col flex-grow gap-4 bg-transparent">
            <h3 className="font-default text-xl font-bold line-clamp-3 text-foreground group-hover:text-primary transition-colors">
              {post.title}
            </h3>
            {post.excerpt && <p className="text-muted-foreground text-sm line-clamp-2 font-default">
                {post.excerpt.replace(/(<([^>]+)>)/gi, "")}
              </p>}
            <div className="mt-auto pt-6">
              <Link to={post.link || "#"} className="block">
                <Button variant="outline" className="w-full rounded-lg border-primary/20 text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 font-default">
                  Mehr lesen
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>)}
    </div>;
}
export default function LatestNews() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="224333" id="aktuelle-neuigkeiten" className="bg-background text-foreground py-20 px-4 md:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-8 items-start">
          
          {}
          <div className="w-full lg:w-1/4 lg:sticky lg:top-32 flex-shrink-0">
            <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4">
              <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-foreground uppercase tracking-tight leading-tight lg:[writing-mode:vertical-lr] lg:rotate-180">
                Aktuelle News
              </h2>
              <span className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-secondary lg:[writing-mode:vertical-lr] lg:rotate-180">LittleReLoves</span>
            </div>
            <div className="w-12 h-1 bg-primary mt-6 lg:mt-8 lg:ml-auto lg:mr-0 rounded-lg"></div>
            <p className="mt-6 text-muted-foreground text-sm font-default lg:hidden">
              Bleiben Sie auf dem Laufenden über unsere Eröffnung im Sommer 2026 und neue Lieblingsstücke.
            </p>
          </div>

          {}
          <div className="w-full lg:w-3/4">
            <PostsProvider wp_query={{
            post_type: "post",
            per_page: 3
          }}>
              <NewsGridConsumer />
            </PostsProvider>
          </div>

        </div>
      </div>
    </section>;
}